import { get, flatMap, map, sortBy, trim, join } from "lodash";
import { RaceStatusEnum } from "@tvg/ts-types/Race";

const specialTypesMap: Record<string, string> = {
  FUTURE: "future",
  ADVANCE: "advance",
  NONCONSECUTIVEPICK: "special_pick",
  "ADVANCE,NONCONSECUTIVEPICK": "advance_special_pick",
  "FUTURE,NONCONSECUTIVEPICK": "future_special_pick"
};

export const getSpecialWagerType = (race: unknown): string => {
  const specialCardTypes = get(race, "track.specialCardTypes", []);

  const normalized = join(
    sortBy(
      flatMap(specialCardTypes, (type) =>
        map(type.specialCardTypeName.split(","), trim)
      )
    ),
    ","
  );

  return specialTypesMap[normalized] || "none";
};

export const getReadableRaceStatus = (
  code: RaceStatusEnum | string
): string => {
  const statusMap: Record<RaceStatusEnum | string, string> = {
    [RaceStatusEnum.OPEN]: "open",
    [RaceStatusEnum.UP_NEXT]: "up_next",
    [RaceStatusEnum.RACE_OFFICIAL]: "race_official",
    [RaceStatusEnum.RACE_OFF]: "race_off",
    [RaceStatusEnum.MANUALLY_OPENED]: "manually_open",
    [RaceStatusEnum.MANUALLY_CLOSED]: "manually_closed"
  };

  return statusMap[code] ?? "";
};
